import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Tooltip from "@mui/material/Tooltip";
import CButton from "./CButton2";
import CInput from "./CInput2";
import CText from "./CText";
import { Button, IconButton, Typography,Dialog,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  useMediaQuery, } from "@mui/material";
import { useTranslation } from "react-i18next";
// import { CameraAltOutlined, PreviewOutlined } from "@mui/icons-material";
import CameraAltIcon from "@mui/icons-material/AddAPhoto";
import PreviewIcon from "@mui/icons-material/Preview";
import { useTheme } from "@emotion/react";


const StyledTableCell = styled(TableCell)(({ theme, cColor }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#fff",
    color: theme.palette.common.black,
    border: "1px solid black",
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const DEFAULT_PAGE_SIZE = 10;
const CUnderlinedText = ({ cText, cOnClick }) => (
  <Typography
    variant="body2"
    sx={{ textDecoration: "underline", cursor: "pointer", color: "blue" }}
    onClick={cOnClick}
  >
    {cText}
  </Typography>
);

const CTable2 = ({
  cHeaderData,
  cRowData,
  cActualData,
  cTooltipText,
  cIsPagination,
  cSmallSize,
  realPagination=false,
  totalCount=0,
  handlePageChange,
  handleLimitChange,
  resetPage=false,
}) => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(DEFAULT_PAGE_SIZE);
  const { t } = useTranslation();
  const [openImageModal, setOpenImageModal] = React.useState(null);
  const [selectedImages, setSelectedImages] = React.useState({});

const theme = useTheme();

React.useEffect(() => {
  if (resetPage) {
    setPage(0);
  }
}, [resetPage]);

const isMobileOrTablet = useMediaQuery(
  theme.breakpoints.down("md")
);
  const handleFileChange = (event, actualRow) => {
  const files = Array.from(event.target.files);

  setSelectedImages((prev) => ({
    ...prev,
    [actualRow.id]: files, // use unique row id
  }));
};

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (handlePageChange) {
      handlePageChange(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    if (handleLimitChange) {
      handleLimitChange(event.target.value);
    }
  };

  const handleCellData = (rowData, actualRow, rowIndex) => {
    let cellContent;
    let rowDataType = rowData.type;
    if (rowDataType === "M") {
      rowDataType = rowData.actualType(actualRow);
    }
    if (rowDataType === "T") {
      if (rowData.tooltipText) {
        cellContent = (
          <Tooltip title={t(rowData.tooltipText(actualRow))}>
            <span>
              <CText cText={actualRow[rowData.value]} />
            </span>
          </Tooltip>
        );
      } else {
        cellContent = <CText cText={actualRow[rowData.value]} />;
      }
    } else if (rowDataType === "B") {
      cellContent = (
        <CButton
          cText={
            typeof rowData.value === "function"
              ? rowData.value(actualRow)
              : rowData.value
          }
          cColor={
            typeof rowData.color === "function"
              ? rowData.color(actualRow)
              : rowData.color
          }
          cFullWidth={
            typeof rowData.fullWidth === "function"
              ? rowData.fullWidth(actualRow)
              : rowData.fullWidth
          }
          cOnClick={() => rowData.actionV(actualRow)}
          cDisabled={rowData.isDisable(actualRow)}
        />
      );
    } else if (rowDataType === "I" || rowDataType === "IC") {
      let isShow = true;
      if (rowData.status !== undefined && actualRow[rowData.status] === 0) {
        isShow = false;
      }
      if (isShow) {
        cellContent = (
          <CButton
            cSrc={
              rowDataType === "IC" ? rowData.value(actualRow) : rowData.value
            }
            cTooltipText={
              rowDataType === "IC"
                ? rowData.tooltipText(actualRow)
                : rowData.tooltipText
            }
            cOnClick={() =>
              rowData.actionV(actualRow, page * rowsPerPage + rowIndex)
            }
          />
        );
      }
    }
    else if (rowDataType === "IU") {
       const rowId = actualRow.id
      if(actualRow.material_status===1){
      cellContent = (
        <>
        {actualRow.image_link.length !== 0?
          <CButton
            cSrc={
              <PreviewIcon />
            }
            cTooltipText={
              //rowDataType === "IC"
                rowData.tooltipText(actualRow)
                //: rowData.tooltipText
            }
            cOnClick={() =>
              rowData.actionV(actualRow, page * rowsPerPage + rowIndex)
            }
          />
          :
          // <><IconButton
          //   component="span"
          //   onClick={() => {
          //     const fileInput =
          //       document.getElementById(`image-id-${rowId}`);
          //     if (fileInput) {
          //       fileInput.click();
          //     }
          //   }}
          // >
          //  <CameraAltIcon  color="primary"/>  
          //   <input
          //     id={`image-id-${rowId}`}
          //     type="file"
          //     accept="image/*"
          //     capture="environment"
          //     onChange={(e) =>
          //       handleFileChange(e, actualRow)
          //     }
          //     style={{ display: "none" }}
          //     multiple
          //   />
          // </IconButton>
          // {selectedImages[rowId] && (
          //   <Button
          //     variant="contained"
          //     size="small"
          //     onClick={() =>
          //       rowData.actionV(actualRow,selectedImages[rowId], page * rowsPerPage + rowIndex)
          //     }
          //     sx={{fontSize:10}}
          //   >
          //     Upload
          //   </Button>
          // )}
          // </>
          <>
  {/* CAMERA ICON */}
  <IconButton
    component="span"
    onClick={() => {
      // MOBILE/TABLET
      if (isMobileOrTablet) {
        setOpenImageModal(rowId);
      }

      // LAPTOP/DESKTOP
      else {
        const fileInput =
          document.getElementById(
            `gallery-input-${rowId}`
          );

        if (fileInput) {
          fileInput.click();
        }
      }
    }}
  >
    <CameraAltIcon color="primary" />
  </IconButton>

  {/* CAMERA INPUT */}
  <input
    id={`camera-input-${rowId}`}
    type="file"
    accept="image/*"
    capture="environment"
    onChange={(e) =>
      handleFileChange(e, actualRow)
    }
    style={{ display: "none" }}
    multiple
  />

  {/* GALLERY INPUT */}
  <input
    id={`gallery-input-${rowId}`}
    type="file"
    accept="image/*"
    onChange={(e) =>
      handleFileChange(e, actualRow)
    }
    style={{ display: "none" }}
    multiple
  />

  {/* MODAL FOR MOBILE/TABLET */}
  {isMobileOrTablet && (
    <Dialog
      open={openImageModal === rowId}
      onClose={() => setOpenImageModal(null)}
    >
      <DialogTitle>
        Select Option
      </DialogTitle>

      <List>
        {/* OPEN CAMERA */}
        <ListItemButton
          onClick={() => {
            const fileInput =
              document.getElementById(
                `camera-input-${rowId}`
              );

            if (fileInput) {
              fileInput.click();
            }

            setOpenImageModal(null);
          }}
        >
          <ListItemText primary="Open Camera" />
        </ListItemButton>

        {/* OPEN GALLERY */}
        <ListItemButton
          onClick={() => {
            const fileInput =
              document.getElementById(
                `gallery-input-${rowId}`
              );

            if (fileInput) {
              fileInput.click();
            }

            setOpenImageModal(null);
          }}
        >
          <ListItemText primary="Choose From Gallery" />
        </ListItemButton>
      </List>
    </Dialog>
  )}

  {/* UPLOAD BUTTON */}
  {selectedImages[rowId] && (
    <Button
      variant="contained"
      size="small"
      onClick={() =>
        rowData.actionV(
          actualRow,
          selectedImages[rowId],
          page * rowsPerPage + rowIndex
        )
      }
      sx={{ fontSize: 10 }}
    >
      Upload
    </Button>
  )}
</>
          
        }
        </>

        
      )}
    }
    else if (rowDataType === "E") {
      cellContent = (
        <CInput
          cHintText=" "
          cValue={actualRow[rowData.value]}
          cOnChange={rowData.actionV}
          cType={rowData.eType}
        />
      );
    } else if (rowDataType === "L") {
      const tooltipContent = rowData.tooltipText
        ? typeof rowData.tooltipText === "function"
          ? rowData.tooltipText(actualRow)
          : rowData.tooltipText
        : "";

      cellContent = (
        <Tooltip title={tooltipContent} arrow>
          <span>
            <CUnderlinedText
              cText={actualRow[rowData.value]}
              cOnClick={() => rowData.actionV(actualRow)}
            />
          </span>
        </Tooltip>
      );
    }

    return cellContent;
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Table
          aria-label={cTooltipText}
          size={cSmallSize === true ? "small" : "inherit"}
          stickyHeader
        >
          <TableHead>
            <TableRow sx={{ whiteSpace: "nowrap" }}>
              {cHeaderData.map((headData, headIndex) => (
                <StyledTableCell key={headIndex}>{headData}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {cActualData.length > 0 ? (
              cActualData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((actualRow, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    {cRowData.map((rowData, cellIndex) => (
                      <TableCell
                        component="th"
                        scope="row"
                        key={cellIndex}
                        sx={{
                          color:
                            rowData.status === undefined
                              ? "inherit"
                              : actualRow[rowData.status] === 0
                                ? "red"
                                // : "green",
                                : rowData.value == "bin_location" && actualRow["other_materials_in_bin_flag"] == 1 ? "blue" : "green",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {handleCellData(rowData, actualRow, rowIndex)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={cHeaderData.length}
                  sx={{ textAlign: "center" }}
                >
                  {t("no_data")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {cIsPagination && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={realPagination ? totalCount : cActualData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={t("Rows")}
        />
      )}
    </Paper>
  );
};

export default CTable2;
